export function clockedInElsewhereBody(mobileConflict: boolean): string {
  if (mobileConflict) {
    return "The hub is locked while you are clocked in on the mobile labor app. Clock out here to take over on the hub, or clock out in the mobile app.";
  }
  return "The hub is locked while you are clocked in. Clock out to use this page, or clock out and keep the station open as a read-only view.";
}

export function clockedInElsewhereKeepReadOnlyLabel(stationLabel: string, pending: boolean): string {
  if (pending) return "Clocking out...";
  return `Clock out and keep ${stationLabel} read-only`;
}

export function clockedInElsewhereClockOutLabel(mobileConflict: boolean, pending: boolean): string {
  if (pending) {
    return "Clocking out...";
  }
  return mobileConflict ? "Clock out of mobile labor" : "Clock out";
}
